import {
  Box,
  Button,
  Checkbox,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import MoreIcon from "@material-ui/icons/MoreVert";
import { Bagde } from "components/Card";
import { theme } from "config/theme";
import useText from "constants/text";
import { isWarring } from "domains/Parcel/utils/validator";
import { useNewOrderStyles } from "domains/Task/components/Job/styles";
import { Parcel } from "generated/graphql";
import { useCurrentUser } from "hooks";
import {
  DeleteIcon,
  DupliquerIcon,
  EditIcon,
  NewParcelIcon,
  ParcelDescriptionIcon,
  SizeIcon,
  TocollectIcon,
  ValueIcon,
} from "icons";
import React, { useCallback, useEffect, useMemo } from "react";
import styled from "styled-components/macro";
import ActionsGroup from "ui/ActionGroup";
import { uuid } from "utils";
import { Order } from "../types";
import AddParcel from "./AddParcel";
import { ActionsParcel, Checbox, DetailParcel, GridInfo, RecapJob } from "./JobStyled";

const ActionButon = styled(IconButton)`
  padding: 0;
`;

const Actions = styled.div`
  &.normal {
    height: 20px;
    width: 20px;
    display: flex;
    transition: 0.5s;
    border-radius: 5px;
  }
  &.reception {
  }
`;

interface OrderProps {
  order?: Order;
  onAddParcel?: (order: Order) => void;
  onDuplicate?: (order: Order) => void;
  onDelete?: (order: Order) => void;
  onEdit?: (order: Order) => void;
  onClick?: (order: any) => void;
  handleAddParcel?: (order: any) => void;
  activeStep?: number;
  setCheckedOrder?: React.Dispatch<React.SetStateAction<string[]>>;
  checkedOrder?: string[];
  handleClickOrder?: (id: string) => void;
}
export function OrderCollapse({
  order,
  onAddParcel,
  onEdit,
  onDelete,
  onDuplicate,
  handleAddParcel,
  activeStep,
  setCheckedOrder,
  checkedOrder,
  handleClickOrder,
}: OrderProps) {
  const styles = useNewOrderStyles();
  const { text } = useText();
  const [openIconButton, setOpenIconButton] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [parcels, setParcels] = React.useState([]);
  const [curentParcel, setCurentParcel] = React.useState(null);
  const [openParcel, setOpenParcel] = React.useState(false);
  const [isEdited, setIsEdited] = React.useState(false);
  const { user } = useCurrentUser();
  const addOrder = () => {
    setCheckedOrder([...checkedOrder, order._id]);
  };
  const removeOrder = () => {
    const idList = new Set(checkedOrder);
    idList.delete(order._id);
    setCheckedOrder([...idList]);
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (checked) {
      addOrder();
    } else removeOrder();
  };
  const isInValid = useMemo(() => isWarring(order), [order]);
  React.useEffect(() => {
    if (order && order.order_parcels?.length > 0) setParcels([...order.order_parcels]);
  }, [order]);

  const updateParcel = (parcel: Parcel) => {
    const newState = parcels.map((row) => {
      if (row._id === parcel._id) row = parcel;
      return row;
    });

    const ordersData = { ...order, order_parcels: [...newState] };
    handleAddParcel && handleAddParcel({ ...ordersData });
  };

  const isOrderInvalid = useMemo(() => isWarring(order), [order]);

  const handleOnEditedParcel = (editedParcel: Parcel) => {
    updateParcel(editedParcel);
    setOpenParcel(false);
  };

  const handleOnclickEditParcel = (parcel: Parcel) => {
    setIsEdited(true);
    setCurentParcel(parcel);
    setOpenParcel(true);
  };

  const handleOnDeleteParcel = (parcel: Parcel) => {
    const newState = parcels.filter((row) => row._id !== parcel._id);
    const ordersData = { ...order, order_parcels: [...newState] };
    handleAddParcel && handleAddParcel({ ...ordersData });
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const onDuplicateParcel = (parcel: Parcel) => {
    const newParcel: Parcel = {
      ...parcel,
      _id: uuid(),
      parcel_description: "",
    };

    const allParcels = [newParcel, ...parcels];

    const ordersData = { ...order, order_parcels: [...allParcels] };
    handleAddParcel && handleAddParcel({ ...ordersData });
    setParcels((prev) => [...allParcels]);
  };

  const addColisActions = [
    { key: "1", label: text.all.add_parcel },
    { key: "2", label: text.all.select_from_caalog },
  ];

  const handleActionsClick = (key: string) => {
    switch (key) {
      case "1":
        onAddParcel(order);
        break;
      case "2":
        break;
      default:
    }
  };
  useEffect(() => {}, [checkedOrder]);

  const isOrderChecked = useCallback(
    (id: string) => {
      return checkedOrder?.includes(id);
    },
    [checkedOrder]
  );

  const isSmallScreen = theme.breakpoints.down("xs");
  return (
    <>
      <TableContainer component={Paper} style={{ overflowX: "unset" }}>
        <Table aria-label="collapsible table">
          <TableBody>
            <div style={{ borderLeft: activeStep === 2 && "4px solid #399ebf", display: "contents" }}>
              <TableRow className={styles.root}>
                <div
                  className={activeStep !== 2 ? styles.activeInfoOrder : styles.infoOrder}
                  style={{
                    borderLeft:
                      order?.order_receiver?.receiver_phone_number === "" ||
                      order?.order_parcels[0]?.parcel_description === ""
                        ? "4px solid red"
                        : "",

                    backgroundColor: isOrderInvalid ? "#ff7e7f26" : "",
                  }}
                >
                  <div className={styles.checkAndButton} onClick={() => setOpenIconButton(!openIconButton)}>
                    {activeStep !== 2 && (
                      <Checkbox
                        checked={isOrderChecked(order._id)}
                        onChange={handleCheckboxChange}
                        onClick={() => handleClickOrder(order?._id)}
                        className={styles.checkbox}
                      />
                    )}
                    {activeStep !== 2 && (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpenIconButton(!openIconButton)}
                      >
                        <div className={styles.btnCheckDetail}>
                          {openIconButton ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                      </IconButton>
                    )}
                  </div>
                  <div className={activeStep !== 2 ? styles.activeDetailsOrder : styles.detailsOrder}>
                    <div className={activeStep !== 2 ? styles.activeTableCellIcon : styles.tableCellIcon}>
                      <NewParcelIcon width={38} height={40} />
                    </div>
                    <div className={activeStep !== 2 ? styles.activeTableCellName : styles.tableCellName}>
                      <Tooltip
                        title={`${order?.order_receiver?.receiver_firstname} ${order?.order_receiver?.receiver_lastname}`}
                      >
                        <span>{`${order?.order_receiver?.receiver_firstname?.substring(0, 12)}...`}</span>
                      </Tooltip>
                    </div>
                    <div className={activeStep !== 2 ? styles.activeTableCellPhone : styles.tableCellPhone}>
                      {" "}
                      {order?.order_receiver?.receiver_phone_number}
                    </div>
                    <div className={activeStep !== 2 ? styles.activeTableCellAddress : styles.tableCellAddress}>
                      {isSmallScreen
                        ? `${order?.order_receiver?.receiver_address?.address?.substring(0, 25)}...`
                        : order?.order_receiver?.receiver_address?.address}
                    </div>
                  </div>
                  <div className={styles.addParcelActions}>
                    <div className={styles.btnAddParcel}>
                      {activeStep !== 2 && (
                        <ActionsGroup
                          padding="0 50px"
                          actions={addColisActions}
                          buttonName={text.all.add_parcels}
                          isParcel
                          onClick={handleActionsClick}
                        />
                      )}
                    </div>
                    <div className={styles.activebadge}>
                      {activeStep !== 2 && (
                        <Box>
                          <Bagde
                            value={order?.order_parcels.map((p) => p).length.toString()}
                            height={17}
                            width={17}
                            variante="contained"
                            fontSize={8}
                          />
                        </Box>
                      )}
                      {activeStep === 2 && (
                        <Box>
                          <div className={styles.recapBadgeItem}>{parcels?.length.toString()}</div>
                          <div className={styles.recapBadgeText}>
                            <span>{text.all.parcel}</span>
                          </div>
                        </Box>
                      )}
                    </div>
                    <div className={styles.actions}>
                      {" "}
                      <Actions>
                        {!true && (
                          <Button
                            variant="outlined"
                            className={styles.newParcel}
                            color="primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              onAddParcel(order);
                            }}
                          >
                            {text.all.add_parcels}
                          </Button>
                        )}
                        {activeStep !== 2 && (
                          <ActionButon aria-label="display more actions" color="default" onClick={handleClick}>
                            <MoreIcon />
                          </ActionButon>
                        )}

                        {true && (
                          <Menu
                            id="long-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={open}
                            onClose={handleCloseMenu}
                            PaperProps={{
                              style: {
                                maxHeight: 48 * 4.5,
                                width: "13ch",
                                marginTop: "2.4rem",
                                marginLeft: "-0.5rem",
                              },
                            }}
                          >
                            <MenuItem
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCloseMenu();
                                onEdit(order);
                              }}
                            >
                              {text.all.edit}
                            </MenuItem>
                            <MenuItem
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCloseMenu();
                                onDuplicate(order);
                              }}
                            >
                              {text.all.duplicate}
                            </MenuItem>
                            <MenuItem
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCloseMenu();
                                onDelete(order);
                              }}
                            >
                              {text.all.delete}
                            </MenuItem>
                          </Menu>
                        )}
                      </Actions>
                    </div>
                  </div>
                </div>
              </TableRow>
              <TableRow style={{ border: "none" }}>
                <TableCell
                  style={{
                    display: `${!openIconButton ? "none" : ""}`,
                    borderLeft: "4px solid #399ebf",
                  }}
                  colSpan={6}
                >
                  <Collapse in={openIconButton} timeout="auto" unmountOnExit style={{ marginLeft: "-20px" }}>
                    <Box>
                      <div className={styles.tableParcel} style={{ margin: "0px !important" }}>
                        <Table>
                          <TableBody>
                            {parcels.length === 0 ? (
                              <Box className={styles.texteIndicatif}>Ce receveur na pas encore de colis</Box>
                            ) : (
                              parcels.map((parcel: any) => (
                                <>
                                  <TableRow key={parcel?.uid}>
                                    <RecapJob
                                      style={{
                                        borderLeft: !parcel?.parcel_description ? "4px solid red" : "",
                                      }}
                                    >
                                      <Checbox>
                                        <div style={{ padding: "3px" }} className={styles.check}>
                                          <Checkbox />
                                        </div>
                                      </Checbox>
                                      <DetailParcel>
                                        <GridInfo>
                                          <ParcelDescriptionIcon />
                                          <div className={styles.iconRef}>
                                            <Box>Refference: {parcel?.parcel_client_reference}</Box>
                                            <Box>Description: {parcel?.parcel_description}</Box>
                                          </div>
                                        </GridInfo>
                                        <GridInfo>
                                          <SizeIcon />
                                          <div className={styles.icon}>
                                            <Box className={styles.iconBox}>Size:</Box>
                                            {parcel?.parcel_size}(Max 5kg)
                                          </div>
                                        </GridInfo>
                                        <GridInfo>
                                          <ValueIcon />
                                          <div className={styles.icon}>
                                            <Box className={styles.iconBox}>Value:</Box>
                                            {parcel?.parcel_value} CFA
                                          </div>
                                        </GridInfo>
                                        <GridInfo>
                                          <TocollectIcon />
                                          <div className={styles.icon}>
                                            <Box className={styles.iconBox}>To collect:</Box>
                                            {parcel?.parcel_amount_to_collect} CFA
                                          </div>
                                        </GridInfo>
                                      </DetailParcel>
                                      <ActionsParcel>
                                        <div onClick={() => handleOnDeleteParcel(parcel)}>
                                          <DeleteIcon color="#399ebf" />
                                        </div>

                                        <div onClick={() => onDuplicateParcel(parcel)}>
                                          <DupliquerIcon color="#399ebf" />
                                        </div>

                                        <div onClick={() => handleOnclickEditParcel(parcel)}>
                                          <EditIcon color="#399ebf" />
                                        </div>
                                      </ActionsParcel>
                                    </RecapJob>
                                  </TableRow>
                                </>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </div>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </div>
          </TableBody>
        </Table>
      </TableContainer>
      <AddParcel
        isEdited={isEdited}
        open={openParcel}
        handleClose={() => setOpenParcel(false)}
        parcel={curentParcel}
        user={user}
        handleOnEditedParcel={handleOnEditedParcel}
      />
    </>
  );
}

export default OrderCollapse;
